import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/Logo";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) setError(res.error);
    else navigate("/dashboard");
  };

  const presets = [
    { label: "Admin", e: "admin@buildquote.co", p: "Admin@2026" },
    { label: "Customer", e: "customer@buildquote.co", p: "Test@2026" },
    { label: "Estimator", e: "estimator@buildquote.co", p: "Test@2026" },
    { label: "Surveyor", e: "surveyor@buildquote.co", p: "Test@2026" },
    { label: "PM", e: "pm@buildquote.co", p: "Test@2026" },
  ];

  return (
    <div className="min-h-screen grid md:grid-cols-2" style={{ background: "var(--bq-bg)" }}>
      <div className="hidden md:flex bq-dark text-white p-12 flex-col justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="login-brand">
          <Logo variant="word" height={28} linkTo={null} invert testId="login-brand-logo" />
        </Link>
        <div>
          <div className="overline text-white/60 mb-4">Welcome back</div>
          <h1 className="font-display text-5xl font-extrabold leading-tight">
            Your projects.<br />
            One transparent<br />
            command center.
          </h1>
        </div>
        <div className="text-xs text-white/50">© Plan2Build · Built for South African contractors</div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-md">
          <div className="overline mb-2">Sign in</div>
          <h2 className="font-display text-3xl font-extrabold">Access your workspace</h2>
          <p className="text-sm text-[var(--bq-text-muted)] mt-2">
            Don&apos;t have an account?{" "}
            <Link to="/register" className="text-[var(--bq-orange)] font-semibold" data-testid="link-register">
              Create one
            </Link>
            .
          </p>

          <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <label className="overline">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
                className="mt-1 w-full px-3 py-2.5 bg-white border border-[var(--bq-border)] rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--bq-orange)]"
                placeholder="you@company.co.za"
              />
            </div>
            <div>
              <label className="overline">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
                className="mt-1 w-full px-3 py-2.5 bg-white border border-[var(--bq-border)] rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--bq-orange)]"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div className="text-sm text-[var(--bq-red)] bg-red-50 border border-red-100 rounded-md px-3 py-2" data-testid="login-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bq-orange-btn py-2.5 rounded-md font-semibold disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-8">
            <div className="overline">Quick demo logins</div>
            <div className="mt-3 flex flex-wrap gap-2">
              {presets.map((p) => (
                <button
                  key={p.label}
                  data-testid={`preset-${p.label.toLowerCase()}`}
                  onClick={() => { setEmail(p.e); setPassword(p.p); }}
                  className="px-3 py-1.5 text-xs border border-[var(--bq-border)] rounded-md hover:border-[var(--bq-navy)] transition-all"
                >
                  {p.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
